import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

import { CompetencyScopeSection } from "./helpers";

// How far a competency (or a role's responsibility) reaches, as an icon
// before its name: the whole company, several tracks (or a department's), or
// one track. The Viewing picker uses the same three.
const iconTypes = {
  company: "globe02",
  shared: "users",
  track: "user",
} as const;

const ScopeSectionIcon = ({
  scope,
  className,
}: {
  scope: CompetencyScopeSection;
  className?: string;
}) => (
  <TopicflowIcon
    type={iconTypes[scope]}
    className={classNames("h-4 w-4 shrink-0 text-gray-500", className)}
  />
);

export default ScopeSectionIcon;
